export const sectionConstants = {
  GETALL_REQUEST: 'SECTIONS_GETALL_REQUEST',
  GETALL_SUCCESS: 'SECTIONS_GETALL_SUCCESS',
  GETALL_FAILURE: 'SECTIONS_GETALL_FAILURE',
};
